export const formatOptions = function (
  options,
  type,
  value = "value",
  label = "label"
) {
  let formatText = "";
  options.forEach((item) => {
    if (item[value] == type) {
      formatText = item[label];
      return;
    }
  });
  return formatText;
};

export const isQiankun = function () {
  if (window.__POWERED_BY_QIANKUN__) {
    return true;
  } else {
    return false;
  }
};
